import { Comparable, Trackable } from '@stylehaven/components';

class RecordId {}

export interface IApiNotification {
    Id: string;
    Title: string;
    Body: string;
    Action: string;
    Tag: string;
    New: boolean;
    SentOn: string;
    RecordId: RecordId;
}

export class ApiNotification implements Comparable, Trackable {
    Id: string;
    Title: string;
    Body: string;
    Action: string;
    Tag: string;
    New: boolean;
    SentOn: string;
    RecordId: RecordId;

    constructor(notification: IApiNotification) {
        this.Id = notification.Id;
        this.Title = notification.Title;
        this.Body = notification.Body;
        this.Action = notification.Action;
        this.Tag = notification.Tag;
        this.New = notification.New;
        this.SentOn = notification.SentOn;
        this.RecordId = notification.RecordId;
    }

    equals(other: any): boolean {
        if (!(other instanceof ApiNotification)) {
            return false;
        }
        return this.Id === other.Id;
    }

    trackBy(): string {
        return this.Id;
    }
}
